// @ts-nocheck

export const ON_MY_MATCH_TOGGLE_TRANSITION_DURATION = 600; // ms
